// extracted by mini-css-extract-plugin
export default {"TimeScaleLabel":"TimeScaleLabel_TimeScaleLabel__8gSNS","TimeScaleLabel__time":"TimeScaleLabel_TimeScaleLabel__time__p1rBX"};